import React, { useState, useEffect, useCallback } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Modal } from "react-bootstrap";
import _ from "lodash";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { NewpromoCategoryModal } from "./NewpromoCategoryModal";
import { CopyDiscountGroupModal } from "./CopyPromoCategoryModal";
import DataGridAmusementServicePromoCategory from "./DataGridAmusementServices";
import { tools } from "../../../core/utils/tools";
import { useLocation, useNavigate } from "react-router-dom";
import GlobalFormControl from "../_Components/GlobalFormControl";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiRegion from "../../../core/api/api.region";

const Index = () => {
  const [listData, setListData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const [cities, setCities] = useState([])
  const searchParams = new URLSearchParams(location.search);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [showModalPromoCategory, setShowModalPromoCategory] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState()
  const [showCopyDiscountGroupModal, setShowCopyDiscountGroupModal] = useState(false);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;


  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPromoCategory.getAll({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        const allAmusementCityList = await ApiRegion.getAllCity();
        setCities(allAmusementCityList.map(city =>
        ({
          label: city.id + "-" + city.name,
          value: city.id
        })
        ))
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);

      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    const apiData = await ApiPromoCategory.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
    tools.setPageNumber(data, searchParams, setValue);
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/promoCategory?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">گروه های تخفیفی</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست گروه های تخفیفی ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setShowCopyDiscountGroupModal(true);
              }}
              className="mr-4"
            >
              <AddCircle className="mr-1" />
              کپی گروه تخفیف
            </Button>
            <Button
              onClick={() => {
                setShowModalPromoCategory(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد تخفیف جدید
            </Button>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0 text-center">
                <DataGridAmusementServicePromoCategory data={listData} cities={cities} setShowModalPromoCategory={setShowModalPromoCategory} setSelectedOffer={setSelectedOffer} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>{" "}
      {showModalPromoCategory && (
        <NewpromoCategoryModal
          showModalPromoCategory={showModalPromoCategory}
          setShowModalPromoCategory={setShowModalPromoCategory}
          selectedItem={selectedOffer}
          setSelectedOffer={setSelectedOffer}
        />
      )}
      {showCopyDiscountGroupModal && (
        <CopyDiscountGroupModal
          showCopyDiscountGroupModal={showCopyDiscountGroupModal}
          setShowCopyDiscountGroupModal={setShowCopyDiscountGroupModal}
          listData={listData}
        />
      )}
    </div>
  );
};

export default Index;
